const endpoints = {
  getSocialMediaFormOptions: `/api/v1/social-media/meta`,
  SocialMediaContent: `/api/v1/social-media/generate`,
};
export default endpoints;
